import DVCApi from './_dvcApi';
import httpClient from '@/apis/base/httpclient';
class DVCFileC205API extends DVCApi {
  constructor() {
    super();
  }
  controllerName = 'DVCFileC205s';
}
export default new DVCFileC205API();
